module.exports = __webpack_public_path__ + "img/ArrowLeft.0e6bfb22.svg";